import { AnfrageListDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-list-display-model";
import { GlobalEnumsAceXfoundportalobjekt } from "@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt";
import { AnfrageContract } from "../models/abstractions/anfrage.contract";
import { ProjektList } from "../models/projekt-list";
import { ProjektideeList } from "../models/projektidee-list";

export class AnfrageListFactory
{
    public create(anfrage: AnfrageListDisplayModel): AnfrageContract | null
    {
        if (anfrage == undefined)
            return null;

        if (anfrage?.objektTyp == undefined)
            return null;

        switch(anfrage.objektTyp)
        {
            case GlobalEnumsAceXfoundportalobjekt.Projekt:
                return new ProjektList(anfrage);
            case GlobalEnumsAceXfoundportalobjekt.Projektidee:
                return new ProjektideeList(anfrage);
            default:
                throw new Error("AnfrageFactory: AnfrageListDisplayModel.objektTyp not implemented");
        }
    }
}